import { atom } from 'recoil';

export const commonState = atom({
    key: 'commonState', // 고유한 key 값 설정
    default: {
        awards: null,
        etcOptions: null,
        gameTypes: null,
        paymentTypes: null,
        eventTypes: null,
        teeboxTypes: null,
        mealTypes: null,
        roomTypes: null,
        fn: {
            getNameWithId: (commonData, id) => {
                return commonData?.find((cd) => {
                    return String(cd.id) === String(id);
                })?.name;
            },
        },
    },
});
